import {Card, Heading, Link, Grid, Text} from '@primer/react-brand'
import type {ImageLinkItem} from '../../../../lib/types/contentful'
import {renderWithNoMarks} from '../../utils'
import type {Document} from '@contentful/rich-text-types'

export type FlexSuiteRiverFootstepsProps = {
  heading?: Document
  label?: string
  cta?: {href: string; text: string}
  cards?: ImageLinkItem[]
}

// This custom implementation will be replaced with a new Primer Brand Component, when available.
export function FlexSuiteRiverFootsteps({heading, label, cta, cards}: FlexSuiteRiverFootstepsProps) {
  const riverCards = cards?.map(c => {
    const id = c.sys.id
    const card = c.fields
    const imageUrl = card.image?.fields.file.url
    const imageAlt = card.image?.fields.description || ''
    if (!imageUrl) return null
    return (
      <Grid.Column span={{small: 12, medium: 6}} key={id}>
        <Card href={card.href}>
          <Card.Image src={imageUrl} alt={imageAlt} />
          {card.label && <Card.Label>{card.label}</Card.Label>}
          {card.heading && <Card.Heading>{renderWithNoMarks(card.heading)}</Card.Heading>}
        </Card>
      </Grid.Column>
    )
  })
  return (
    <Grid>
      <Grid.Column span={{small: 12, medium: 4}}>
        {label && <Text>{label.toUpperCase()}</Text>}
        {heading && <Heading as="h3">{renderWithNoMarks(heading)}</Heading>}
        {cta && (
          <Link variant="accent" href={cta.href}>
            {cta.text}
          </Link>
        )}
      </Grid.Column>
      <Grid.Column span={{small: 12, medium: 8}} start={{small: 1, medium: 5}}>
        <Grid>{riverCards}</Grid>
      </Grid.Column>
    </Grid>
  )
}
